import { render, staticRenderFns } from "./answer2.vue?vue&type=template&id=50bead88&scoped=true"
import script from "./answer2.vue?vue&type=script&lang=js"
export * from "./answer2.vue?vue&type=script&lang=js"
import style0 from "./answer2.vue?vue&type=style&index=0&id=50bead88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bead88",
  null
  
)

export default component.exports